module.exports = __webpack_public_path__ + "static/img/logo_white.359b2f23.svg";